// ANCHOR Base
import { Block } from 'baseui/block';
import { HeadingXSmall, LabelMedium } from 'baseui/typography';

// ANCHOR Models
import {
  useFormSubmissionQuestionItemQuestionId,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';
import {
  FormQuestionAnswersData,
  useFormQuestionAnswersData,
} from '@lyon/scoped-models/form/FormQuestionAnswersData';

// ANCHOR Utils
import { formatCountLabel } from '@lyon/utils/extras/formatCountLabel';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';

const CorrectAnswerContent = constant(() => {
  const answers = useFormQuestionAnswersData();
  const correctAnswers = answers?.filter((answer) => answer.points);

  if (!correctAnswers) {
    return <Loader />;
  }

  if (correctAnswers.length === 0) {
    return (
      <LabelMedium>
        No correct answer/s
      </LabelMedium>
    );
  }

  const label = formatCountLabel(correctAnswers.length, 'Correct Answer', {
    includeCount: false,
  });

  return (
    <>
      <LabelMedium>
        {`${label}:`}
      </LabelMedium>
      {
        correctAnswers.map(({ name }) => (
          <HeadingXSmall marginTop="4px" marginBottom={0} key={name}>
            {name}
          </HeadingXSmall>
        ))
      }
    </>
  );
});

export const LyonViewAnswerFormQuestionCorrectAnswer = constant(() => {
  const questionId = useFormSubmissionQuestionItemQuestionId();

  if (!questionId) {
    return <Loader />;
  }

  return (
    <Block paddingTop="16px" paddingBottom="16px">
      <FormQuestionAnswersData.Provider id={questionId}>
        <CorrectAnswerContent />
      </FormQuestionAnswersData.Provider>
    </Block>
  );
});
